import { put, call, takeEvery, select, all } from "redux-saga/effects";
import _ from 'lodash';
import moment from 'moment-timezone';
import { APP, ENDPOINT } from "../constants";

import {
    setSeasonData,
    setMissionData,
    setTagSavingLoader,
    setReportStatusSavingLoader,
    setSelectedTag,
    setCommentSavingLoader,
    setAssetComment,
    setSelectedReportTag,
    setSelectedReportStatus,
    setSelectedTagNtt,
} from '../actions';

import {
    getJwtToken,
    getDataFromKpiDash,
} from '../api';
import {
    HINAN_KUNREN_COMMON_ACCESS_KEY,
    HINAN_KUNREN_SEASON_ID,
} from '../config/HinanKunrenConfig';

export const startDate = state => state.app.dateRange[0];
export const endDate = state => state.app.dateRange[1];
export const selectedTag = state => state.app.selectedTag;
export const assetComment = state => state.app.assetComment;
export const selectedReportTag = state => state.app.selectedReportTag;
export const selectedTagNtt = state => state.app.selectedTagNtt;
export const selectedReportStatus = state => state.app.selectedReportStatus;

const keywords = ["当別町", "苫前町", "体験ミッション", "にいがた", "島めぐり", "国際通り", "那覇市", "SHIBUYA GAMES", "札幌市", "函館市", "帯広市", "芽室町", "蘭越町", "標茶町"];
const nttMeMissionKeywords = ["SHIBUYA GAMES"];
const nttFtMissionKeywords = ["島めぐり", "国際通り", "那覇市"];
const hokudenMissionKeywords = ["札幌市", "函館市", "帯広市", "芽室町", "蘭越町", "標茶町"];

const getLocalStorageItem = (key) => {
  return localStorage.getItem(key);
};

const escapeSqlString = (value) => String(value ?? "")
  .replace(/\\/g, "\\\\")
  .replace(/'/g, "''");

export function* handleSeasonData() {
  try {
    const jwtToken = yield call(getJwtToken);
    let loading = "loading";
    let dateFrom = yield select(startDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format("YYYY-MM-DD");
    let dateTo = yield select(endDate);
    dateTo = moment(dateTo).tz("Asia/Tokyo").format("YYYY-MM-DD");

    const sqlQueryGetSeason = {
      query: `
        SELECT gs.id           AS 'seasonId'
            ,sn.official_name  AS 'seasonName'
            ,gt.start_datetime AS 'seasonStart'
            ,gt.end_datetime   AS 'seasonEnd'
            ,sn.abbreviation_name AS 'seasonAbbreviation'
        FROM game_space gs
        INNER JOIN game_term gt ON gt.id = gs.game_term_id
        INNER JOIN season_name sn ON sn.season_id = gs.id AND sn.language_code = 'JA'
        ORDER BY gt.start_datetime DESC
      `,
    };
    const [dataSeasonDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetSeason,
          ENDPOINT.GET_DATA_API_REPLICA
        ),
      ]);

    const seasonData = JSON.parse(dataSeasonDataTemp.body);
    let seasons = [], seasonObj = {};
    if (localStorage.getItem('access_key') === "qf70ypdjdzm89ypqvc4r7nf9") {
      // ntt me
      _.each(seasonData, function(s) {
        if (s.seasonId === "cmadtlnih0001n3mx1wvl9zog" || // aomori
          s.seasonId === "cmd5oyfft0001iho10o2iceha" || // iwate
          s.seasonId === "cmb68qvei00011vo0e591229z" || // hokkaido
          s.seasonId === "cmr0bus0w00010azches0f7ak" || // hokkaido 2026
          s.seasonId === "cmg7iw3va00017bow596s39cs" || // nagano
          s.seasonId === "cmg7iw3vc00037bowekjy65pc" || // tochigi
          s.seasonId === "cmkdvml9l0001ngs48zepg7ne" || // tokyo kanagawa chiba
          s.seasonId === "cmp4yz2lj00017rtcc4ok0jgv" || // regular season
          s.seasonId === "cmrz0wo8t0000bpzcana86bow" // regular season 2
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = s.seasonId === "cmb68qvei00011vo0e591229z"
            ? moment("2025-08-09T00:00:00.000Z").tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm")
            : moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === "lqdp4c7fuwgfz89og7q4x9f3") {
      // hokuden
      _.each(seasonData, function(s) {
        if (
          s.seasonId === "cmc9114580001sapdecondxjw" ||
          s.seasonId === "cmb68qvei00011vo0e591229z" ||
          s.seasonId === "cmr0bus0w00010azches0f7ak") { // hokkaido battle
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === "z7n3q9m1x4p2v0ydk8twr5fb") {
      // ntt-ft
      _.each(seasonData, function(s) {
        if (
          s.seasonId === "cmkdxxnxn000141s4asb2gdfv"
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === "k4x9d2p7m0v1q8t5wryb3zfn6") {
      // okiden
      _.each(seasonData, function(s) {
        if (
          s.seasonId === "cmkdxxnxn000141s4asb2gdfv"
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === HINAN_KUNREN_COMMON_ACCESS_KEY) {
      // Common
      _.each(seasonData, function(s) {
        if (
          s.seasonId === HINAN_KUNREN_SEASON_ID
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else {
      // tepco
      _.each(seasonData, function(s) {
        if (s.seasonId !== "clxvw56es00005soo28mj4jfs" &&
          s.seasonId !== "cm46zidp10001bpp63r3cfhwx" && // akita 1
          s.seasonId !== "cm64mqm94000br3n0esu8c0n4" && // kitakanto
          s.seasonId !== "cm46zidp30003bpp6cxq101mo" &&
          s.seasonId !== "cmadtlnih0001n3mx1wvl9zog" && // aomori
          s.seasonId !== "cmb68qvei00011vo0e591229z" && // hokkaido
          s.seasonId !== "cmr0bus0w00010azches0f7ak" && // hokkaido
          s.seasonId !== "cmc9114580001sapdecondxjw" &&// hokkaido
          s.seasonId !== "cmd5oyfft0001iho10o2iceha" &&// iwate
          s.seasonId !== "cmg7iw3va00017bow596s39cs" && // nagano
          s.seasonId !== "cmg7iw3vc00037bowekjy65pc" && // tochigi
          s.seasonId !== "cmkdvml9l0001ngs48zepg7ne" && // tokyo kanagawa chiba
          s.seasonId !== "cmkdxxnxn000141s4asb2gdfv" && // ft okinawa
          s.seasonId !== "cmp4yz2lj00017rtcc4ok0jgv" && // reulgar season1
          s.seasonId !== "cmrz0wo8t0000bpzcana86bow" && // regular season2
          s.seasonId !== HINAN_KUNREN_SEASON_ID // hinan kunren
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    }
    seasons.sort((a, b) => {
      return moment(b.seasonStart, "YYYY-MM-DD HH:mm").valueOf() -
            moment(a.seasonStart, "YYYY-MM-DD HH:mm").valueOf();
    });
    // console.log("LOG seasons:", seasons);
    yield put(setSeasonData(seasons));
  } catch (error) {
    console.log(error);
  }
}

export function* handleMissionData(action) {
  try {
    let dateFrom = yield select(startDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format("YYYY-MM-DD");
    let dateTo = yield select(endDate);
    dateTo = moment(dateTo).tz("Asia/Tokyo").format("YYYY-MM-DD");
    const isDeaAdmin = action.payload.isDeaAdmin;
    const companyName = action.payload.companyName;

    let missionNameQuery =
      !isDeaAdmin
        ? "WHERE " + keywords.map(k => `mn.name NOT LIKE '%${k}%'`).join(" AND ")
        : "";

    if (companyName === "tepco") {
      missionNameQuery = "WHERE " + keywords.map(k => `mn.name NOT LIKE '%${k}%'`).join(" AND ")
    }

    if (companyName === "mitsubishi") {
      missionNameQuery = "WHERE mn.name LIKE '%カーブミラー撮影ミッション%'";
    }

    if (companyName === "ntt") {
      missionNameQuery = "WHERE " + nttMeMissionKeywords.map(k => `mn.name LIKE '%${k}%'`).join(" OR ")
    }

    if (companyName === "ntt-ft" || companyName === "okiden") {
      missionNameQuery = "WHERE " + nttFtMissionKeywords.map(k => `mn.name LIKE '%${k}%'`).join(" OR ")
    }

    if (companyName === "hokuden") {
      missionNameQuery = "WHERE " + hokudenMissionKeywords.map(k => `mn.name LIKE '%${k}%'`).join(" OR ")
    }

    const sqlQueryGetMission = {
      query: `
        SELECT gs.id          AS 'missionId'
            ,mn.name           AS 'missionName'
            ,gt.start_datetime AS 'missionStart'
            ,gt.end_datetime   AS 'missionEnd'
        FROM game_space gs
        INNER JOIN game_term gt
        ON gt.id = gs.game_term_id
        INNER JOIN mission m
        ON gs.id = m.id
        INNER JOIN mission_name mn
        ON mn.mission_id = m.id AND mn.language_code = 'JA'
        ${missionNameQuery}
        ORDER BY gt.start_datetime ASC
      `,
    };
    const [dataMissionDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetMission,
          ENDPOINT.GET_DATA_API_REPLICA
        ),
      ]);

    const missionData = JSON.parse(dataMissionDataTemp.body);
    let missions = [], missionObj = {};
    _.each(missionData, function(m) {
      if (m.missionId !== "cm0zde85z000407506byxr3bu" &&
        m.missionName !== "京都スタンプラリー" &&
        m.missionName.indexOf("動作確認") === -1 &&
        m.missionName.indexOf("建物撮影") === -1
      ) {
        missionObj.missionId = m.missionId;
        missionObj.missionName = m.missionName;
        missionObj.missionStart = moment(m.missionStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
        missionObj.missionEnd = moment(m.missionEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
        missions.push(missionObj);
        missionObj = {};
      }
    });
    missions.reverse();
    yield put(setMissionData(missions));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedTagData() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedTag);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingTag.fileName; //savingTag.fileName.split(".")[0];
    const objectKey = savingTag.object_key;
    const occurredDatetime = savingTag.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingTag.game_space_id;
    const gameSpaceType = savingTag.game_space_type;
    const reviewRequestId = savingTag.review_request_id;
    const photoOfPowerAssetId = savingTag.photo_of_power_asset_id;
    const placeCode = savingTag.place_code;
    const signNumber = savingTag.sign_number;
    const equipmentNumber = savingTag.equipment_number;
    const playerId = savingTag.player_id;
    const playerName = savingTag.player_name;
    const tagArryString = JSON.stringify(savingTag.tags);
    const tagCommaString = savingTag.tags.map(String).join(',');
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const fileNameSql = escapeSqlString(fileName);
    const objectKeySql = escapeSqlString(objectKey);
    const occurredDatetimeSql = escapeSqlString(occurredDatetime);
    const gameSpaceIdSql = escapeSqlString(gameSpaceId);
    const gameSpaceTypeSql = escapeSqlString(gameSpaceType);
    const reviewRequestIdSql = escapeSqlString(reviewRequestId);
    const photoOfPowerAssetIdSql = escapeSqlString(photoOfPowerAssetId);
    const placeCodeSql = escapeSqlString(placeCode);
    const signNumberSql = escapeSqlString(signNumber);
    const equipmentNumberSql = escapeSqlString(equipmentNumber);
    const playerIdSql = escapeSqlString(playerId);
    const playerNameSql = escapeSqlString(playerName);
    const tagArryStringSql = escapeSqlString(tagArryString);
    const tagCommaStringSql = escapeSqlString(tagCommaString);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);

    const table = env === 'prod' ? "PicTreeViewerTagProd" : "PicTreeViewerTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
      `,
      type: "select"
    };

    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getTagDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateTag = {
        query: `
          UPDATE ${table}
          SET tag_array = '${tagArryStringSql}', tag_flat = '${tagCommaStringSql}', logDate = '${utcDateTimeSql}'
          WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
        `,
        type: "write"
      };
      const [updateTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG updateTagDataTemp:", updateTagDataTemp);
    } else {
      // INSERT
      const sqlQuerySetTag = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, tag_array, tag_flat, private, logDate) VALUES ('${usernameSql}', '${emailSql}', '${fileNameSql}', '${objectKeySql}', '${occurredDatetimeSql}', '${gameSpaceIdSql}', '${gameSpaceTypeSql}','${reviewRequestIdSql}', '${photoOfPowerAssetIdSql}', '${placeCodeSql}', '${signNumberSql}','${equipmentNumberSql}', '${playerIdSql}', '${playerNameSql}', '${tagArryStringSql}', '${tagCommaStringSql}', 0, '${utcDateTimeSql}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetTag:", sqlQuerySetTag.query);
      const [setTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setTagDataTemp:", setTagDataTemp);
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedTagDataByFileName(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerTagProd" : "PicTreeViewerTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        fileName: getTagDataTemp[0][3]["stringValue"], //row.fileName
        tags: JSON.parse(getTagDataTemp[0][15]["stringValue"]),  // Array of selected tags
      }
      yield put(setSelectedTag(savedTagData));
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedCommentData() {
  try {
    const env = process.env.REACT_APP_ENV;
    yield put(setCommentSavingLoader(true));
    const savingComment = yield select(assetComment);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingComment.fileName;
    const objectKey = savingComment.object_key;
    const occurredDatetime = savingComment.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingComment.game_space_id;
    const gameSpaceType = savingComment.game_space_type;
    const reviewRequestId = savingComment.review_request_id;
    const photoOfPowerAssetId = savingComment.photo_of_power_asset_id;
    const placeCode = savingComment.place_code;
    const signNumber = savingComment.sign_number;
    const equipmentNumber = savingComment.equipment_number;
    const playerId = savingComment.player_id;
    const playerName = savingComment.player_name;
    const comment = savingComment.comment;
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const fileNameSql = escapeSqlString(fileName);
    const objectKeySql = escapeSqlString(objectKey);
    const occurredDatetimeSql = escapeSqlString(occurredDatetime);
    const gameSpaceIdSql = escapeSqlString(gameSpaceId);
    const gameSpaceTypeSql = escapeSqlString(gameSpaceType);
    const reviewRequestIdSql = escapeSqlString(reviewRequestId);
    const photoOfPowerAssetIdSql = escapeSqlString(photoOfPowerAssetId);
    const placeCodeSql = escapeSqlString(placeCode);
    const signNumberSql = escapeSqlString(signNumber);
    const equipmentNumberSql = escapeSqlString(equipmentNumber);
    const playerIdSql = escapeSqlString(playerId);
    const playerNameSql = escapeSqlString(playerName);
    const commentSql = escapeSqlString(comment);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);

    const table = env === 'prod' ? "PicTreeViewerCommentProd" : "PicTreeViewerCommentDev";
    const sqlQueryGetComment = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
      `,
      type: "select"
    };

    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetComment,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getCommentDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateComment = {
        query: `
          UPDATE ${table}
          SET comment = '${commentSql}', logDate = '${utcDateTimeSql}'
          WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
        `,
        type: "write"
      };
      const [updateCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQuerySetComment = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, comment, private, logDate) VALUES ('${usernameSql}', '${emailSql}', '${fileNameSql}', '${objectKeySql}', '${occurredDatetimeSql}', '${gameSpaceIdSql}', '${gameSpaceTypeSql}','${reviewRequestIdSql}', '${photoOfPowerAssetIdSql}', '${placeCodeSql}', '${signNumberSql}','${equipmentNumberSql}', '${playerIdSql}', '${playerNameSql}', '${commentSql}', 0, '${utcDateTimeSql}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetComment:", sqlQuerySetComment.query);
      const [setCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setCommentDataTemp:", setCommentDataTemp);
    }
    yield put(setCommentSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedCommentDataByFileName(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerCommentProd" : "PicTreeViewerCommentDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getCommentDataTemp.length > 0) {
      yield put(setAssetComment(getCommentDataTemp[0][15]["stringValue"])); // Fill up
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedReportTagData() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedReportTag);
    console.log("LOG: savingReportResultTag: ", savingTag);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');
    const reportId = savingTag.report_id;
    const fileName = !savingTag.file_name ? "false" : savingTag.file_name.split(".")[0];
    const fileUrl = !savingTag.file_url ? "false" : savingTag.file_url;
    const occurredDatetime = savingTag.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingTag.game_space_id;
    const photoOfPowerAssetId = savingTag.power_asset_id;
    const placeCode = savingTag.place_code;
    const signNumber = savingTag.sign_number;
    const equipmentNumber = savingTag.equipment_number;
    const playerId = savingTag.player_id;
    const playerName = savingTag.player_name;
    const tagArryString = JSON.stringify(savingTag.tags);
    const tagCommaString = savingTag.tags.map(String).join(',');
    const resultTagArryString = JSON.stringify(savingTag.result_tags);
    const resultTagCommaString = savingTag.result_tags.map(String).join(',');
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);
    const reportIdSql = escapeSqlString(reportId);
    const fileNameSql = escapeSqlString(fileName);
    const fileUrlSql = escapeSqlString(fileUrl);
    const occurredDatetimeSql = escapeSqlString(occurredDatetime);
    const gameSpaceIdSql = escapeSqlString(gameSpaceId);
    const photoOfPowerAssetIdSql = escapeSqlString(photoOfPowerAssetId);
    const placeCodeSql = escapeSqlString(placeCode);
    const signNumberSql = escapeSqlString(signNumber);
    const equipmentNumberSql = escapeSqlString(equipmentNumber);
    const playerIdSql = escapeSqlString(playerId);
    const playerNameSql = escapeSqlString(playerName);
    const tagArryStringSql = escapeSqlString(tagArryString);
    const tagCommaStringSql = escapeSqlString(tagCommaString);
    const resultTagArryStringSql = escapeSqlString(resultTagArryString);
    const resultTagCommaStringSql = escapeSqlString(resultTagCommaString);

    const table = env === 'prod' ? "PicTreeViewerReportTagProd" : "PicTreeViewerReportTagDev";
    const sqlQueryGetReportResultTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${emailSql}' AND report_id = '${reportIdSql}';
      `,
      type: "select"
    };

    const [getReportResultTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetReportResultTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getReportResultTagDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateReportResultTag = {
        query: `
          UPDATE ${table}
          SET result_tag_array = '${resultTagArryStringSql}', result_tag_flat = '${resultTagCommaStringSql}', logDate = '${utcDateTimeSql}'
          WHERE user_email = '${emailSql}' AND report_id = '${reportIdSql}';
        `,
        type: "write"
      };
      const [updateReportResultTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateReportResultTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQueryReportResultSetTag = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, report_id, file_name, file_url, occurred_datetime, game_space_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, tag_array, tag_flat, result_tag_array, result_tag_flat, private, logDate) VALUES ('${usernameSql}', '${emailSql}', '${reportIdSql}', '${fileNameSql}', '${fileUrlSql}', '${occurredDatetimeSql}', '${gameSpaceIdSql}', '${photoOfPowerAssetIdSql}', '${placeCodeSql}', '${signNumberSql}','${equipmentNumberSql}', '${playerIdSql}', '${playerNameSql}', '${tagArryStringSql}', '${tagCommaStringSql}', '${resultTagArryStringSql}', '${resultTagCommaStringSql}', 0, '${utcDateTimeSql}');
        `,
        type: "write"
      };
      const [setTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryReportResultSetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedReportTagDataByReportId(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const reportId = action.payload;
    const table = env === 'prod' ? "PicTreeViewerReportTagProd" : "PicTreeViewerReportTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE report_id = '${reportId}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        result_tags: JSON.parse(getTagDataTemp[0][16]["stringValue"]),  // Array of selected tags
      }
      yield put(setSelectedReportTag(savedTagData));
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedReportStatusDataByReportId(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const reportId = action.payload;
    const table = env === 'prod' ? "PicTreeViewerReportStatusProd" : "PicTreeViewerReportStatusDev";
    const sqlQueryGetStatus = {
      query: `
        SELECT report_id, report_status, report_status_label, report_status_saved_by, flag_removed, flag_reset, report_tag, report_type, operator_code
        FROM ${table}
        WHERE report_id = '${reportId}';
      `,
      type: "select"
    };
    const [getStatusDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetStatus,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getStatusDataTemp.length > 0) {
      const savedStatusData = {
        report_id: getStatusDataTemp[0][0]["stringValue"],
        report_status: getStatusDataTemp[0][1]["stringValue"],
        report_status_label: getStatusDataTemp[0][2]["stringValue"],
        report_status_saved_by: getStatusDataTemp[0][3]["stringValue"],
        flag_removed: getStatusDataTemp[0][4]["longValue"],
        flag_reset: getStatusDataTemp[0][5]["longValue"],
        report_tag: getStatusDataTemp[0][6]["stringValue"],
        report_type: getStatusDataTemp[0][7]["stringValue"],
        company: getStatusDataTemp[0][8]["stringValue"],
      }
      yield put(setSelectedReportStatus(savedStatusData));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedTagDataNtt() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedTagNtt);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const username = yield call(getLocalStorageItem, "username");
    const email = yield call(getLocalStorageItem, "email");

    const table = env === 'prod' ? "PicTreeViewerResultTagNttProd" : "PicTreeViewerResultTagNttDev";

    const {
      fileName,
      object_key,
      occurred_datetime,
      game_space_id,
      player_id,
      player_name,
      review_request_id,
      power_asset_id,
      power_asset_photography_target_id,
      game_term_id,
      game_field_id,
      prefectural_area,
      exchange_office_name,
      asset_info,
      photography_target,
      tags, // "true" / "false" / "pending"
      reject_reason,
      latitude,
      longitude,
      sub_type,
    } = savingTag;

    const occurredDatetime = occurred_datetime?.slice(0, 19).replace('T', ' ');
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);
    const fileNameSql = escapeSqlString(fileName);
    const objectKeySql = escapeSqlString(object_key);
    const occurredDatetimeSql = escapeSqlString(occurredDatetime);
    const gameSpaceIdSql = escapeSqlString(game_space_id);
    const playerIdSql = escapeSqlString(player_id);
    const playerNameSql = escapeSqlString(player_name);
    const reviewRequestIdSql = escapeSqlString(review_request_id);
    const powerAssetIdSql = escapeSqlString(power_asset_id);
    const powerAssetPhotographyTargetIdSql = escapeSqlString(power_asset_photography_target_id);
    const gameTermIdSql = escapeSqlString(game_term_id);
    const gameFieldIdSql = escapeSqlString(game_field_id);
    const prefecturalAreaSql = escapeSqlString(prefectural_area);
    const exchangeOfficeNameSql = escapeSqlString(exchange_office_name);
    const assetInfoSql = escapeSqlString(asset_info);
    const photographyTargetSql = escapeSqlString(photography_target);
    const tagsSql = escapeSqlString(tags);
    const rejectReasonSql = reject_reason ? escapeSqlString(reject_reason) : null;
    const subTypeSql = escapeSqlString(sub_type);

    // Step 1: check if record exists
    const sqlQueryCheck = {
      query: `
        SELECT COUNT(*) FROM ${table}
        WHERE player_id = '${playerIdSql}'
          AND review_request_id = '${reviewRequestIdSql}';
      `,
      type: "select"
    };

    const [existingRows] = yield all([
      call(getDataFromKpiDash, sqlQueryCheck, ENDPOINT.GET_DATA_KPIDASH_API),
    ]);

    if (existingRows[0][0]["longValue"] == 1) {
      // Step 2: UPDATE
      const sqlQueryUpdate = {
        query: `
          UPDATE ${table}
          SET tag = '${tagsSql}',
              reject_reason = ${rejectReasonSql ? `'${rejectReasonSql}'` : 'NULL'},
              user_id = '${usernameSql}',
              user_email = '${emailSql}',
              log_date = '${utcDateTimeSql}'
          WHERE file_name = '${fileNameSql}'
            AND player_id = '${playerIdSql}'
            AND review_request_id = '${reviewRequestIdSql}';
        `,
        type: "write"
      };

      yield all([
        call(getDataFromKpiDash, sqlQueryUpdate, ENDPOINT.GET_DATA_KPIDASH_API),
      ]);
    } else {
      const sqlQueryInsert = {
        query: `
          INSERT INTO ${table} (
            file_name,
            object_key,
            occurred_datetime,
            game_space_id,
            player_id,
            player_name,
            review_request_id,
            power_asset_id,
            power_asset_photography_target_id,
            game_term_id,
            game_field_id,
            prefectural_area,
            exchange_office_name,
            asset_info,
            photography_target,
            tag,
            reject_reason,
            user_id,
            user_email,
            log_date,
            latitude,
            longitude,
            sub_type
          ) VALUES (
            '${fileNameSql}',
            '${objectKeySql}',
            '${occurredDatetimeSql}',
            '${gameSpaceIdSql}',
            '${playerIdSql}',
            '${playerNameSql}',
            '${reviewRequestIdSql}',
            '${powerAssetIdSql}',
            '${powerAssetPhotographyTargetIdSql}',
            '${gameTermIdSql}',
            '${gameFieldIdSql}',
            '${prefecturalAreaSql}',
            '${exchangeOfficeNameSql}',
            '${assetInfoSql}',
            '${photographyTargetSql}',
            '${tagsSql}',
            ${rejectReasonSql ? `'${rejectReasonSql}'` : 'NULL'},
            '${usernameSql}',
            '${emailSql}',
            '${utcDateTimeSql}',
            ${latitude},
            ${longitude},
            '${subTypeSql}'
          );
        `,
        type: "write"
      };

      yield all([
        call(getDataFromKpiDash, sqlQueryInsert, ENDPOINT.GET_DATA_KPIDASH_API),
      ]);
    }

    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.error("handleSetSavedTagDataNtt ERROR:", error);
    yield put(setTagSavingLoader(false));
  }
}

export function* handleGetSavedTagDataByFileNameNtt(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerResultTagNttProd" : "PicTreeViewerResultTagNttDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE review_request_id = '${fileName}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        fileName: getTagDataTemp[0][1]["stringValue"], //row.fileName
        tags: getTagDataTemp[0][16]["stringValue"],  // Array of selected tags
        reject_reason: getTagDataTemp[0][16]["stringValue"] === "false" ? getTagDataTemp[0][17]["stringValue"] : "",
      }
      yield put(setSelectedTagNtt(savedTagData)); // Fill up
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedCommentDataHokuden() {
  try {
    const env = process.env.REACT_APP_ENV;
    yield put(setCommentSavingLoader(true));
    const savingComment = yield select(assetComment);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingComment.fileName;
    const objectKey = savingComment.object_key;
    const occurredDatetime = savingComment.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingComment.game_space_id;
    const gameSpaceType = savingComment.game_space_type;
    const reviewRequestId = savingComment.review_request_id;
    const photoOfPowerAssetId = savingComment.photo_of_power_asset_id;
    const powerPoleNumber = savingComment.power_pole_number;
    const cityName = savingComment.city_name;
    const cityCode = savingComment.city_code;
    const branchCode = savingComment.branch_code;
    const playerId = savingComment.player_id;
    const playerName = savingComment.player_name;
    const comment = savingComment.comment;
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const fileNameSql = escapeSqlString(fileName);
    const objectKeySql = escapeSqlString(objectKey);
    const occurredDatetimeSql = escapeSqlString(occurredDatetime);
    const gameSpaceIdSql = escapeSqlString(gameSpaceId);
    const gameSpaceTypeSql = escapeSqlString(gameSpaceType);
    const reviewRequestIdSql = escapeSqlString(reviewRequestId);
    const photoOfPowerAssetIdSql = escapeSqlString(photoOfPowerAssetId);
    const powerPoleNumberSql = escapeSqlString(powerPoleNumber);
    const cityNameSql = escapeSqlString(cityName);
    const cityCodeSql = escapeSqlString(cityCode);
    const branchCodeSql = escapeSqlString(branchCode);
    const playerIdSql = escapeSqlString(playerId);
    const playerNameSql = escapeSqlString(playerName);
    const commentSql = escapeSqlString(comment);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);

    const table = env === 'prod' ? "PicTreeViewerCommentHokudenProd" : "PicTreeViewerCommentHokudenDev";
    const sqlQueryGetComment = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
      `,
      type: "select"
    };

    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetComment,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getCommentDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateComment = {
        query: `
          UPDATE ${table}
          SET comment = '${commentSql}', logDate = '${utcDateTimeSql}'
          WHERE user_email = '${emailSql}' AND file_name = '${fileNameSql}';
        `,
        type: "write"
      };
      const [updateCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQuerySetComment = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, power_pole_number, city_name, city_code, branch_code, player_id, player_name, comment, private, logDate) VALUES ('${usernameSql}', '${emailSql}', '${fileNameSql}', '${objectKeySql}', '${occurredDatetimeSql}', '${gameSpaceIdSql}', '${gameSpaceTypeSql}','${reviewRequestIdSql}', '${photoOfPowerAssetIdSql}', '${powerPoleNumberSql}', '${cityNameSql}','${cityCodeSql}', '${branchCodeSql}', '${playerIdSql}', '${playerNameSql}', '${commentSql}', 0, '${utcDateTimeSql}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetComment:", sqlQuerySetComment.query);
      const [setCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setCommentDataTemp:", setCommentDataTemp);
    }
    yield put(setCommentSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedCommentDataByFileNameHokuden(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerCommentHokudenProd" : "PicTreeViewerCommentHokudenDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getCommentDataTemp.length > 0) {
      yield put(setAssetComment(getCommentDataTemp[0][16]["stringValue"])); // Fill up
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedReportStatusData() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setReportStatusSavingLoader(true));
    const savingStatus = yield select(selectedReportStatus);
    if (!savingStatus || !savingStatus.report_status) {
      yield put(setReportStatusSavingLoader(false));
      return;
    }

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const reportId = savingStatus.report_id;
    const occurredDatetime = savingStatus.occurred_datetime
      ? savingStatus.occurred_datetime.slice(0, 19).replace('T', ' ')
      : null;
    const gameSpaceId = savingStatus.game_space_id;
    const photoOfPowerAssetId = savingStatus.power_asset_id;
    const placeCode = savingStatus.place_code;
    const signNumber = savingStatus.sign_number;
    const signName = savingStatus.sign_name;
    const equipmentNumber = savingStatus.equipment_number;
    const equipmentCode = savingStatus.equipment_code;
    const playerId = savingStatus.player_id;
    const playerName = savingStatus.player_name;
    const tagArryString = JSON.stringify(savingStatus.tags || []);
    const tagCommaString = (savingStatus.tags || []).map(String).join(',');
    const reportStatus = savingStatus.report_status;
    const reportStatusLabel = savingStatus.report_status_label || savingStatus.report_status;
    const reportStatusSavedBy = savingStatus.report_status_saved_by;
    const operatorCode = savingStatus.company || "unknown";
    const operatorName = savingStatus.company || "unknown";
    const reportTag = savingStatus.report_tag || tagCommaString || "unknown";
    const reportType = savingStatus.report_type
      || ((savingStatus.tags || []).some((tag) => String(tag).includes("営巣")) ? "nest" : "unknown");
    const flagRemoved = savingStatus.flag_removed ? 1 : 0;
    const flagReset = savingStatus.flag_reset ? 1 : 0;
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');

    const reportIdSql = escapeSqlString(reportId);
    const operatorCodeSql = escapeSqlString(operatorCode);
    const operatorNameSql = escapeSqlString(operatorName);
    const reportTypeSql = escapeSqlString(reportType);
    const reportTagSql = escapeSqlString(reportTag);
    const reportStatusSql = escapeSqlString(reportStatus);
    const reportStatusLabelSql = escapeSqlString(reportStatusLabel);
    const reportStatusSavedBySql = escapeSqlString(reportStatusSavedBy);
    const usernameSql = escapeSqlString(username);
    const emailSql = escapeSqlString(email);
    const playerIdSql = escapeSqlString(playerId);
    const playerNameSql = escapeSqlString(playerName);
    const gameSpaceIdSql = escapeSqlString(gameSpaceId);
    const photoOfPowerAssetIdSql = escapeSqlString(photoOfPowerAssetId);
    const placeCodeSql = escapeSqlString(placeCode);
    const signNumberSql = escapeSqlString(signNumber);
    const signNameSql = escapeSqlString(signName);
    const equipmentCodeSql = escapeSqlString(equipmentCode);
    const equipmentNumberSql = escapeSqlString(equipmentNumber);
    const tagArryStringSql = escapeSqlString(tagArryString);
    const tagCommaStringSql = escapeSqlString(tagCommaString);
    const utcDateTimeSql = escapeSqlString(utcDateTime);
    const occurredDatetimeSql = occurredDatetime ? escapeSqlString(occurredDatetime) : null;

    const table = env === 'prod' ? "PicTreeViewerReportStatusProd" : "PicTreeViewerReportStatusDev";
    const historyTable = env === 'prod' ? "PicTreeViewerReportStatusHistoryProd" : "PicTreeViewerReportStatusHistoryDev";
    const sqlQueryGetStatus = {
      query: `
        SELECT id FROM ${table}
        WHERE report_id = '${reportIdSql}' AND operator_code = '${operatorCodeSql}' AND report_type = '${reportTypeSql}';
      `,
      type: "select"
    };

    const [getStatusDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetStatus,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getStatusDataTemp.length > 0) {
      const reportStatusId = getStatusDataTemp[0][0]["longValue"];
      // UPDATE
      const sqlQueryUpdateStatus = {
        query: `
          UPDATE ${table}
          SET report_status = '${reportStatusSql}',
              report_status_label = '${reportStatusLabelSql}',
              report_status_saved_by = '${reportStatusSavedBySql}',
              flag_removed = ${flagRemoved},
              flag_reset = ${flagReset},
              tag_array = '${tagArryStringSql}',
              tag_flat = '${tagCommaStringSql}',
              logDate = '${utcDateTimeSql}'
          WHERE id = ${reportStatusId};
        `,
        type: "write"
      };
      const [updateStatusDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateStatus,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG updateStatusDataTemp:", updateStatusDataTemp);

      const sqlQueryInsertHistory = {
        query: `
          INSERT INTO ${historyTable}
          (report_status_id, report_id, report_type, operator_code, report_status, report_status_label, report_status_saved_by, flag_removed, flag_reset, status_changed_at, note)
          VALUES (${reportStatusId}, '${reportIdSql}', '${reportTypeSql}', '${operatorCodeSql}', '${reportStatusSql}', '${reportStatusLabelSql}', '${reportStatusSavedBySql}', ${flagRemoved}, ${flagReset}, '${utcDateTimeSql}', NULL);
        `,
        type: "write"
      };
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryInsertHistory,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    } else {
      // INSERT
      const sqlQuerySetStatus = {
        query: `
          INSERT INTO ${table}
          (operator_code, operator_name, report_type, report_id, report_tag, report_status, report_status_label, report_status_saved_by, user_id, user_email, player_id, player_name, game_space_id, photo_of_power_asset_id, place_code, sign_number, sign_name, equipment_code, equipment_number, occurred_datetime, flag_removed, flag_reset, tag_array, tag_flat, logDate)
          VALUES ('${operatorCodeSql}', '${operatorNameSql}', '${reportTypeSql}', '${reportIdSql}', '${reportTagSql}', '${reportStatusSql}', '${reportStatusLabelSql}', '${reportStatusSavedBySql}', '${usernameSql}', '${emailSql}', '${playerIdSql}', '${playerNameSql}', '${gameSpaceIdSql}', '${photoOfPowerAssetIdSql}', '${placeCodeSql}', '${signNumberSql}', '${signNameSql}', '${equipmentCodeSql}', '${equipmentNumberSql}', ${occurredDatetimeSql ? `'${occurredDatetimeSql}'` : 'NULL'}, ${flagRemoved}, ${flagReset}, '${tagArryStringSql}', '${tagCommaStringSql}', '${utcDateTimeSql}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetStatus:", sqlQuerySetStatus.query);
      const [setStatusDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetStatus,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setStatusDataTemp:", setStatusDataTemp);

      const sqlQueryGetInsertedId = {
        query: `
          SELECT id FROM ${table}
          WHERE report_id = '${reportIdSql}' AND operator_code = '${operatorCodeSql}' AND report_type = '${reportTypeSql}';
        `,
        type: "select"
      };
      const [getInsertedIdTemp] = yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetInsertedId,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

      if (getInsertedIdTemp.length > 0) {
        const reportStatusId = getInsertedIdTemp[0][0]["longValue"];
        const sqlQueryInsertHistory = {
          query: `
            INSERT INTO ${historyTable}
            (report_status_id, report_id, report_type, operator_code, report_status, report_status_label, report_status_saved_by, flag_removed, flag_reset, status_changed_at, note)
            VALUES (${reportStatusId}, '${reportIdSql}', '${reportTypeSql}', '${operatorCodeSql}', '${reportStatusSql}', '${reportStatusLabelSql}', '${reportStatusSavedBySql}', ${flagRemoved}, ${flagReset}, '${utcDateTimeSql}', NULL);
          `,
          type: "write"
        };
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryInsertHistory,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      }
    }
    yield put(setReportStatusSavingLoader(false));
  } catch (error) {
    console.log(error);
    yield put(setReportStatusSavingLoader(false));
  }
}

export default function* watchMapSettings() {
  yield takeEvery(APP.GET_SEASON_DATA, handleSeasonData);
  yield takeEvery(APP.GET_MISSION_DATA, handleMissionData);
  yield takeEvery(APP.SET_SAVED_SELECTED_TAG_DATA, handleSetSavedTagData);
  yield takeEvery(APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME, handleGetSavedTagDataByFileName);
  yield takeEvery(APP.SET_SAVED_COMMENT_DATA, handleSetSavedCommentData);
  yield takeEvery(APP.GET_SAVED_COMMENT_DATA_BY_FILENAME, handleGetSavedCommentDataByFileName);
  yield takeEvery(APP.SET_SAVED_SELECTED_REPORT_TAG_DATA, handleSetSavedReportTagData);
  yield takeEvery(APP.GET_SAVED_SELECTED_REPORT_TAG_DATA_BY_REPORT_ID, handleGetSavedReportTagDataByReportId);
  yield takeEvery(APP.GET_SAVED_SELECTED_REPORT_STATUS_DATA_BY_REPORT_ID, handleGetSavedReportStatusDataByReportId);
  yield takeEvery(APP.SET_SAVED_SELECTED_TAG_DATA_NTT, handleSetSavedTagDataNtt);
  yield takeEvery(APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_NTT, handleGetSavedTagDataByFileNameNtt);
  yield takeEvery(APP.SET_SAVED_COMMENT_DATA_HOKUDEN, handleSetSavedCommentDataHokuden);
  yield takeEvery(APP.GET_SAVED_COMMENT_DATA_BY_FILENAME_HOKUDEN, handleGetSavedCommentDataByFileNameHokuden);
  yield takeEvery(APP.SET_SAVED_SELECTED_REPORT_STATUS_DATA, handleSetSavedReportStatusData);
}
